import { EDjangoAppsEndpoints } from '../enums/EDjangoAppsEndpoints';
import { type IFundDTO } from '../models/IFundDTO';
import CoreJsonAPIService from './CoreJsonAPIService';

export class SvFundServices extends CoreJsonAPIService {
  static async getAll() {
    return await super.get<IFundDTO[]>(EDjangoAppsEndpoints.funds);
  }
}
